import { BaseRequestResult } from "./request";

/**
 * The backend answers a conflict with an envelope whose `errorType` is `CONFLICT`
 * (`HTTP_YERROR_NAME_MAP` in create_http_yerror.ts). That name is the signal worth keying on:
 * it survived the backend's renumbering of conflict from 410 to 409 unchanged, where the number
 * did not.
 *
 * The 409 stays as a fallback because a bare `res.sendStatus()` sends no body.
 */
export const isConflictResult = (result?: BaseRequestResult | null): boolean => {
  if (!result) return false;
  return conflictErrorType(result) === "CONFLICT" || result.statusCode === 409;
};

const conflictErrorType = (result: BaseRequestResult): string | undefined =>
  (result.payload as { errorType?: string } | null)?.errorType;

/**
 * The backend's own words for why it refused, from the envelope's `errorHint`. It is developer
 * prose, so callers match it rather than showing it, and must stay correct when it is absent.
 */
export const conflictErrorHint = (result?: BaseRequestResult | null): string =>
  (result?.payload as { errorHint?: string } | null)?.errorHint ?? "";
